<template>
  <div class="">
    <div class="seachBox">
      <div class="seachList">
        <span class="name">客户名称：</span>
        <a-select
          placeholder="请输入客户名称"
          v-model="search.company"
          class="seachs"
          :default-active-first-option="false"
          :filter-option="false"
          :not-found-content="null"
          :options="options"
          :show-arrow="false"
          show-search
          @change="handleChange"
          @search="handleSearch"
        >
        </a-select>
      </div>
      <div class="seachList">
        <span class="name">网站类型：</span>
        <a-select
          v-model="search.site_type"
          placeholder="请选择"
          class="seachs"
          allowClear
        >
          <a-select-option
            :value="item.value"
            :key="index"
            v-for="(item, index) in seachList.site_type_list"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachList">
        <span class="name">统计日期：</span>
        <a-range-picker
          class="seachs seachs-time"
          v-model="search.statistics_date"
          allowClear
          :showTime="false"
          format="YYYY-MM-DD"
        />
      </div>
      <div class="seachList" style="padding-left: 20px;">
        <a-button type="primary" class="top_btn" @click="getList()"
          >搜索</a-button
        >
        <a-button class="top_btn" @click="resetSeach()">重置</a-button>
      </div>
    </div>
    <div class="flex">
      <div>
        <a-button class="top_btn" type="primary" @click="exportList()">
          导出
        </a-button>
        <span style="margin-left: 8px;">
          <template v-if="hasSelected">
            {{ `选中 ${selectedRowKeys.length} 项` }}
          </template></span
        >
      </div>
    </div>
    <p
      style="margin-bottom: 12px;"
      class="statis-num"
      v-if="
        statisToken.prompt_tokens_total || statisToken.completion_tokens_total
      "
    >
      总输入{{ statisToken.prompt_tokens_total }}token、总输出{{
        statisToken.completion_tokens_total
      }}token
    </p>
    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="pagination"
      rowKey="id"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
    >
      <span slot="total_tokens" slot-scope="text, record">
        <a @click="openUseTokenModal(text.id)">{{ record.total_tokens }}</a>
      </span>
    </a-table>
    <!-- 使用token明细 -->
    <UseTokenModal ref="useTokenModalRef"></UseTokenModal>
  </div>
</template>

<script>
import API from "./api";
import moment from "moment";
import { debounce } from "@/utils/utils";
import UseTokenModal from "./comp/use-token-modal/index.vue";
// sorter: true,

const nowdate = () => {
  let nowdate = new Date();
  nowdate.setMonth(nowdate.getMonth() - 1);
  let y = nowdate.getFullYear();
  let m = nowdate.getMonth() + 1;
  let d = nowdate.getDate();
  return y + "-" + m + "-" + d;
};
const columns = [
  {
    title: "项目名称",
    key: "company",
    ellipsis: true,
    dataIndex: "company",
    minWidth: "150px"
  },
  {
    title: "网站类型",
    key: "site_type_text",
    ellipsis: true,
    dataIndex: "site_type_text",
    minWidth: "150px"
  },
  {
    title: "输入token",
    dataIndex: "prompt_tokens_total",
    ellipsis: true,
    key: "prompt_tokens_total",
    minWidth: "110px"
  },
  {
    title: "输出token",
    dataIndex: "completion_tokens_total",
    ellipsis: true,
    key: "completion_tokens_total",
    minWidth: "110px"
  },
  {
    title: "总计（输入+输出）",
    dataIndex: "total_tokens",
    ellipsis: true,
    key: "total_tokens",
    minWidth: "160px",
    scopedSlots: { customRender: "total_tokens" }
  }
];
export default {
  name: "index",
  data() {
    return {
      loading: true,
      data: [],
      columns,
      selectedRowKeys: [],
      search: {
        site_type: "",
        company: "",
        statistics_date: []
      },
      seachList: {
        site_type_list: []
      },
      page: 1,
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showQuickJumper: true
      },
      options: [],
      statisToken: {
        completion_tokens_total: "",
        prompt_tokens_total: ""
      }
    };
  },
  components: {
    UseTokenModal
  },
  created() {
    this.$store.state.adminleftnavnum = "/DataStatistics/tokenStatistics"; //设置左侧导航2-2 active
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    }
  },

  methods: {
    openUseTokenModal(id) {
      this.$refs.useTokenModalRef.open(id);
    },
    handleSearch: debounce(function (val) {
      this.handleSearchFn(val);
    }, 300),
    handleSearchFn(val) {
      this.options = [];
      //下拉模糊查询
      if (val) {
        this.getSeachList(val);
      }
    },
    handleChange(value) {
      if (value == undefined) return;
      this.getList();
    },
    getSeachList(company) {
      API.service.GET_NAME({ company }).then((res) => {
        res.data.data.forEach((item) => {
          this.options.push({
            value: item.id,
            label: item.company
          });
        });
      });
    },
    resetSeach() {
      this.loading = true;
      this.search = {
        site_type: "",
        company: "",
        statistics_date: []
      };
      this.seachList.site_type_list = [];
      this.getList(1);
    },
    exportList(page) {
      if (this.search.statistics_date.length > 0) {
        this.search.statistics_date[0] = moment(
          this.search.statistics_date[0]
        ).format("YYYY-MM-DD");
        this.search.statistics_date[1] = moment(
          this.search.statistics_date[1]
        ).format("YYYY-MM-DD");
      }
      let seachData = JSON.parse(JSON.stringify(this.search));
      API.service
        .GET_LIST({
          ...seachData,
          ids: this.selectedRowKeys,
          export: 1,
          page: page || 1
        })
        .then((res) => {
          if (res.data.code == 20010) {
            this.exportList(res.data.data.page);
          } else if (res.data.code == 1) {
            window.open(
              `${this.$store.state.urlExper}${res.data.data.url.substr(1)}`
            );
          }
        });
    },
    getList(page) {
      this.loading = true;
      this.page = page || this.page;
      if (this.search.statistics_date.length > 0) {
        this.search.statistics_date[0] = moment(
          this.search.statistics_date[0]
        ).format("YYYY-MM-DD");
        this.search.statistics_date[1] = moment(
          this.search.statistics_date[1]
        ).format("YYYY-MM-DD");
      }
      let seachData = JSON.parse(JSON.stringify(this.search));
      API.service
        .GET_LIST({ page: this.page || 1, ...seachData })
        .then((res) => {
          if (res.data.data.list) {
            this.data = res.data.data.list.data;
          } else {
            this.data = [];
          }
          if (this.data.length > 0) {
            this.pagination.total = res.data.data.list.total;
            this.pagination.pageSize = res.data.data.list.per_page;
            this.pagination.current = res.data.data.list.current_page;
          } else {
            this.description = "暂无数据";
          }
          this.seachList.site_type_list = res.data.data.site_type_list;
          this.selectedRowKeys = [];
          this.loading = false;
          this.statisToken.completion_tokens_total =
            res.data.data.completion_tokens_total;
          this.statisToken.prompt_tokens_total =
            res.data.data.prompt_tokens_total;
        });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    }
  },
  mounted() {
    this.search["statistics_date"] = [nowdate(), nowdate()];
    this.getList();
  }
};
</script>
<style scoped>
.inputs {
  display: inline-block;
  width: 70px;
}
.search-group {
  float: right;
}
.search-group .ant-input {
  width: 200px;
  margin: 0 8px 0 0;
}
.button-group {
  float: left;
}
#list_order {
  width: 50px;
}
.top .flex {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 16px;
  box-sizing: border-box;
  width: 60%;
  margin-bottom: 20px;
}
.seachBox {
  display: flex;
}
.seachBox .seachList {
  flex-wrap: nowrap;
  display: flex;
  width: 20%;
  margin: 5px 0;
}
/*.seachs-time{min-width: 220px;}*/
.seachBox .seachList .name {
  white-space: nowrap;
}
</style>
